import * as React from 'react';
import { DashboardFolderT } from 'business/definitions';
import GenericCard from 'ui/Card/GenericCard';
import FolderSharedOutlinedIcon from '@mui/icons-material/FolderSharedOutlined';
import DashboardFolderEditMenu from 'routes/AllDashboards/components/DashboardFolderEditMenu/DashboardFolderEditMenu';
import DashboardIcon from '@mui/icons-material/Dashboard';

type Props = {
    folder: DashboardFolderT;
    onClick?: () => void;
};

const DashboardFolderCard = ({
    folder,
    onClick = () => {},
}: Props): React.ReactElement => {
    return (
        <GenericCard
            isFolder
            title={folder.name}
            icon={<FolderSharedOutlinedIcon />}
            action={
                <DashboardFolderEditMenu dashboardFolder={folder} show small />
            }
            onClick={onClick}
            className="pendo-folder-card"
            chipIcon={<DashboardIcon />}
            chipLabel={`${folder.dashboards.length}`}
            size="md"
        />
    );
};

export default DashboardFolderCard;
